import React from 'react';
import PropTypes from 'prop-types';
import HStack from '../Stack/HStack';
import Box from '../Box';
import useDesignUtils from '../../../hooks/useDesignUtils';
import { isObject } from 'lodash';
import { resolveFontFamilyByWeight } from '../../../helpers/index';

const ButtonBase = ({
  type,
  children,
  iconStart,
  iconEnd,
  loading,
  size,
  disabled,
  backgroundColor,
  color,
  textDecoration,
  borderColor,
  borderRadius = 'large',
  horizontalCenter = true,
  tag = 'button',
  href,
  noSpaces,
  hover,
  ...restProps
}) => {
  const { theme } = useDesignUtils();
  const responsiveFontSizes = restProps.fontSize
    ? theme.fontSizes[restProps.fontSize]
    : theme.fontSizes['smallCopy'];
  const isDisabled = isObject(disabled)
    ? Object.keys(disabled).length > 0
    : disabled;

  return (
    <Box
      type={tag !== 'a' ? type : undefined}
      tag={tag}
      borderRadius={borderRadius}
      width={size === 'full' ? '100%' : size}
      paddingX={noSpaces ? 'none' : 'medium'}
      marginY={noSpaces ? 'none' : 'xsmall'}
      borderWidth="1px"
      borderStyle="solid"
      height={noSpaces ? 'auto' : '45px'}
      backgroundColor={isDisabled ? 'disabled' : backgroundColor}
      $color={isDisabled ? 'lightGray' : color}
      $fontWeight="medium"
      $fontFamily={resolveFontFamilyByWeight()}
      $fontSize={responsiveFontSizes}
      textDecoration={isDisabled ? 'none' : textDecoration}
      borderColor={isDisabled ? 'disabled' : borderColor}
      disabled={isDisabled}
      role="button"
      href={tag === 'a' ? href : undefined}
      hover={hover}
      transition="all 200ms ease"
      {...restProps}
    >
      <HStack
        space="small"
        alignItems="center"
        horizontalCenter={horizontalCenter}
      >
        {iconStart && <Box display="flex">{iconStart}</Box>}
        <span>{loading ? 'Cargando...' : children}</span>
        {iconEnd && <Box display="flex">{iconEnd}</Box>}
      </HStack>
    </Box>
  );
};

ButtonBase.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node.isRequired,
  iconStart: PropTypes.node,
  iconEnd: PropTypes.node,
  loading: PropTypes.bool,
  size: PropTypes.string,
  disabled: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  textDecoration: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.string,
  tag: PropTypes.string,
  href: PropTypes.string,
  horizontalCenter: PropTypes.bool,
  noSpaces: PropTypes.bool,
  hover: PropTypes.object,
};

export default ButtonBase;
